// removed by extract-text-webpack-plugin
module.exports = {"searchSpan":"containers-HeaderSearch-index-searchSpan-3Z7BQ","autoComplete":"containers-HeaderSearch-index-autoComplete-26R3X","input":"containers-HeaderSearch-index-input-2Tx7k","autoCompleteShow":"containers-HeaderSearch-index-autoCompleteShow-1cGPE"};


//////////////////
// WEBPACK FOOTER
// ./containers/HeaderSearch/index.css
// module id = 1937
// module chunks = 0